var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Typography as MuiTypography, } from '@mui/material';
var fontWeights = {
    bold: 700,
    semibold: 600,
    medium: 500,
    normal: 400,
};
/**
 * Pigment [Typography](https://pigment.customink.com/?path=/docs/components-typography)
 */
export var Typography = React.forwardRef(function (_a, ref) {
    var fontWeight = _a.fontWeight, weight = _a.weight, _b = _a.variant, variant = _b === void 0 ? 'uiTextDefault' : _b, forwardableProps = __rest(_a, ["fontWeight", "weight", "variant"]);
    return (React.createElement(MuiTypography, __assign({ fontWeight: weight && weight in fontWeights ? fontWeights[weight] : fontWeight, ref: ref, variant: variant }, forwardableProps)));
});
export default Typography;
//# sourceMappingURL=Typography.js.map